export const SEARCH_CATEGORIES = {
  WORKFLOWS: "workflows",
  DATA_RECORDS: "data_objects",
  FILES: "files",
  FIELDS: "fields"
} as const;

export const SEARCH_RESULT_TYPES = {
  WORKFLOWS: "workflows",
  DATA_RECORDS: "data_records",
  FILES: "files"
} as const;

export type SearchResultType =
  (typeof SEARCH_RESULT_TYPES)[keyof typeof SEARCH_RESULT_TYPES];

export const DEFAULT_SEARCH_CATEGORIES = [
  SEARCH_CATEGORIES.WORKFLOWS,
  SEARCH_CATEGORIES.DATA_RECORDS
];

export const WORKFLOW_CATEGORIES_WITH_ADVANCED_FILTERS = [
  SEARCH_CATEGORIES.WORKFLOWS,
  SEARCH_CATEGORIES.FIELDS
];

export const DATA_OBJECT_CATEGORIES_WITH_ADVANCED_FILTERS = [
  SEARCH_CATEGORIES.DATA_RECORDS,
  SEARCH_CATEGORIES.FIELDS
];

export const SEARCH_QUERY_STALE_TIME = 10 * 60 * 1000; // 10 minutes
export const MINIMUM_SEARCH_QUERY_LENGTH = 0;
export const SEARCH_DEBOUNCE_DELAY = 600;

export const SEARCH_LISTBOX_ID = "search-listbox";
export const RECENT_SEARCHES_LISTBOX_ID = "recent-searches";
export const SEARCH_FILTERS_ID = "search-filters";

export const SEARCH_PREVIEW_LIMIT = {
  [SEARCH_RESULT_TYPES.WORKFLOWS]: 7,
  [SEARCH_RESULT_TYPES.DATA_RECORDS]: 5,
  [SEARCH_RESULT_TYPES.FILES]: 7
};
